export default "__VITE_ASSET__B5b3PtWm__"